import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'degerlendirme-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mk-edit">
      <div class="mk-baslik">
        <div class="mk-baslik-ikon" style="background:linear-gradient(135deg,#b45309,#fbbf24)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
        </div>
        <span>Değerlendirme</span>
      </div>
      <div class="mk-form">
        <div class="form-satir-3">
          <div class="form-grup">
            <label>Kalite (1-5)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('kalitePuani') || 3" (ngModelChange)="guncelle('kalitePuani', $event)" [nzMin]="1" [nzMax]="5" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Teslimat (1-5)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('teslimatPuani') || 3" (ngModelChange)="guncelle('teslimatPuani', $event)" [nzMin]="1" [nzMax]="5" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Fiyat (1-5)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('fiyatPuani') || 3" (ngModelChange)="guncelle('fiyatPuani', $event)" [nzMin]="1" [nzMax]="5" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('notlar')" (ngModelChange)="guncelle('notlar', $event)" placeholder="Değerlendirme notları..."/>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .mk-edit { display: flex; flex-direction: column; padding: 0; }
    .mk-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .mk-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(180,83,9,0.35); }
    .mk-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .mk-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #b45309, #fbbf24, #b45309); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap input[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(180,83,9,0.1); outline: none; }
    .input-wrap ::ng-deep .ant-input-number { width: 100% !important; border-radius: 8px; }
  `],
})
export class DegerlendirmeEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
